import request from '@utils/request'

export function fetchLevels(params) {
  return request({
    url: `/admin/security/level`,
    params,
  })
}

export function fetchLevel(seq) {
  return request({
    url: `/admin/security/level/${seq || 0}`,
    method: 'get',
  })
}

export function createLevel(data) {
  return request.post('/admin/security/level', data)
}

export function updateLevel(data) {
  return request.put(`/admin/security/level/${data.seq}`, data)
}

export function deleteLevel(seq) {
  return request.delete(`/admin/security/level/${seq}`)
}

export function fetchLevelConditions(level_seq) {
  return request({
    url: `/admin/security/level/${level_seq || 0}/condition`,
  })
}

export function fetchLevelCondition(level_seq, seq) {
  return request({
    url: `/admin/security/level/${level_seq || 0}/condition/${seq || 0}`,
    method: 'get',
  })
}

export function createLevelCondition({ level_seq, ...data }) {
  return request.post(
    `/admin/security/level/${level_seq || 0}/condition/`,
    data
  )
}

export function updateLevelCondition({ level_seq, seq, ...data }) {
  return request.put(
    `/admin/security/level/${level_seq || 0}/condition/${seq}`,
    data
  )
}

export function deleteLevelCondition(level_seq, seq) {
  return request.delete(
    `/admin/security/level/${level_seq || 0}/condition/${seq}`
  )
}

export function fetchRestrictions(params) {
  return request({
    url: `/admin/security/restriction`,
    params,
  })
}

export function fetchRestriction(seq) {
  return request({
    url: `/admin/security/restriction/${seq || 0}`,
    method: 'get',
  })
}

export function createRestriction(data) {
  return request.post('/admin/security/restriction', data)
}

export function updateRestriction(data) {
  return request.put(`/admin/security/restriction/${data.seq}`, data)
}

export function deleteRestriction(seq) {
  return request.delete(`/admin/security/restriction/${seq}`)
}

export function fetchRestrictionTargets(restriction_seq) {
  return request({
    url: `/admin/security/restriction/${restriction_seq || 0}/target`,
  })
}

export function fetchRestrictionTarget(restriction_seq, seq) {
  return request({
    url: `/admin/security/restriction/${restriction_seq || 0}/target/${seq ||
      0}`,
    method: 'get',
  })
}

export function createRestrictionTarget({ restriction_seq, ...data }) {
  return request.post(
    `/admin/security/restriction/${restriction_seq || 0}/target/`,
    data
  )
}

export function updateRestrictionTarget({ restriction_seq, seq, ...data }) {
  return request.put(
    `/admin/security/restriction/${restriction_seq || 0}/target/${seq}`,
    data
  )
}

export function deleteRestrictionTarget(restriction_seq, seq) {
  return request.delete(
    `/admin/security/restriction/${restriction_seq || 0}/target/${seq}`
  )
}
